import styled from 'styled-components';
import BasicInformation from './BasicInformation';
import ExpectedPeriod from './ExpectedPeriod';
import ExpectedBid from './ExpectedBid';
import ExpectedSaleAndProfit from './ExpectedSaleAndProfit';
import ReturnAnalysis from './ReturnAnalysis';
import QuantCheck from './QuantCheck';
import { s } from './VIPReport.style';

import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import QuantService, { IReportData } from '../../../service/quant/Quant';
import Loading from '../../../func/components/loading/LoadingCircle';
import ExpectedSaleEtcPrc from './ExpectedSaleEtcPrc';

const VIPReport = () => {
  const params = useParams();
  const { quant_idx, index } = params;

  const typeObj = {
    0: '저평가주',
    1: '공시지가보다낮주',
    2: '전세가보다낮주',
    3: '전세우위주',
    4: '월세우위주',
    5: '평균보다낮주',
    6: '하자없주',
    7: '시세차익주',
    8: '저평가부실채권주',
    9: '소액투자주',
    10: '시세상승주',
    11: '이자보다월세주',
  };

  const navigate = useNavigate();

  const [data, setData] = useState<IReportData | null>(null);

  const [loading, setLoading] = useState(false);

  const getData = async () => {
    try {
      setLoading(true);
      const theme = index
        ?.split(',')
        .map((el) => typeObj[parseInt(el) as keyof typeof typeObj])
        .filter(Boolean)
        .join(',');
      let data = await QuantService.report(quant_idx as string, theme);
      setData(data.data as IReportData);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <Loading />;
  }

  const quantcheckData = [
    {
      strategy: '저평가주 (宙)',
      applicable: 'undervaluedStock',
    },
    {
      strategy: '공시지가보다낮주 (宙)',
      applicable: 'belowOfficialPrc',
    },
    {
      strategy: '전세가보다낮주 (宙)',
      applicable: 'belowJeonsePrc',
    },
    {
      strategy: '평균보다낮주 (宙)',
      applicable: 'belowAvgPrc',
    },
    {
      strategy: '하자없주 (宙)',
      applicable: 'defectFree',
    },
    {
      strategy: '시세차익주 (宙)',
      applicable: 'prcGainPotential',
    },
    {
      strategy: '저평가부실채권주 (宙)',
      applicable: 'undervaluedStockNpl',
    },
    {
      strategy: '소액투자주 (宙)',
      applicable: 'smallInvestment',
    },
    {
      strategy: '시세상승주 (宙)',
      applicable: 'prcIncreasePotential',
    },
    {
      strategy: '이자보다월세주 (宙)',
      applicable: 'wolseOverInterest',
    },
    {
      strategy: '전세우위주 (宙)',
      applicable: '',
    },
    {
      strategy: '월세우위주 (宙)',
      applicable: '',
    },
  ];

  return (
    <Container>
      <Header>
        <img
          onClick={() => {
            window.close();
          }}
          src="/assets/images/close/close_black.svg"
        />
      </Header>
      <s.Div style={{ marginTop: '56px', marginBottom: '8px' }}>
        <HeaderDiv>
          <HeaderTop>
            <HeaderTitleDiv>
              <HeaderTitle>VIP 퀀트 투자 분석 리포트</HeaderTitle>
              {index?.split(',').map((el: any) => {
                let index_data = 'N';
                quantcheckData.map((el2: any) => {
                  if (
                    data?.info &&
                    data.info[el2.applicable as 'wolseOverInterest'] === 'Y' &&
                    el2.strategy.includes(typeObj[el as keyof typeof typeObj])
                  ) {
                    index_data = 'Y';
                  }
                });

                if (index_data === 'Y') {
                  return (
                    <CategoryDiv key={el}>
                      {typeObj[el as keyof typeof typeObj]}
                    </CategoryDiv>
                  );
                } else {
                  return null;
                }
              })}
              {/* <CategoryDiv>{typeObj[index as '1']}</CategoryDiv> */}
            </HeaderTitleDiv>
          </HeaderTop>
          <Grid>
            <InfoCell>
              <Title>사건번호</Title>
              <Content>{data?.info.caseNo}</Content>
            </InfoCell>
            <InfoCell>
              <Title>소재지</Title>
              <Content>{data?.info.region}</Content>
            </InfoCell>
            <InfoCell>
              <Title>부동산 종류</Title>
              <Content>{data?.info.category}</Content>
            </InfoCell>
            <InfoCell>
              <Title>경매현황</Title>
              <Content>{data?.info.status}</Content>
            </InfoCell>
          </Grid>
        </HeaderDiv>
      </s.Div>
      <Report>
        <BasicInformation data={data?.info} />
        <ExpectedPeriod data={data?.estimatedHoldingPeriod} />
        <ExpectedBid data={data?.estimated_bid_analysis} />
        <ExpectedSaleAndProfit data={data?.marginAnalysis} />
        <ExpectedSaleEtcPrc data={data?.simulation3} />
        <ReturnAnalysis
          data={{
            simulation1: data?.simulation1,
            simulation2: data?.simulation2,
            simulation3: data?.simulation3,
            simulation4: data?.simulation4,
          }}
        />
        <QuantCheck data={data?.info} />
      </Report>
      <BottomFixed>
        <DetailPageButton
          onClick={() => {
            navigate('/auction/detail/' + data?.info.iidx);
          }}
        >
          상세정보 보러가기 {'>'}
        </DetailPageButton>
      </BottomFixed>
    </Container>
  );
};

export default VIPReport;

const Header = styled.div`
  width: 100%;
  height: 56px;
  background-color: #ffffff;
  padding: 16px;
  position: fixed;
  top: 0;
`;

const Container = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const HeaderTitleDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const HeaderDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const HeaderTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222222;
`;

const CategoryDiv = styled.div`
  width: fit-content;
  padding: 4px 12px;
  background-color: #e6f3ff;
  border-radius: 4px;
  color: #008aff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
`;

const DetailPageButton = styled.div`
  min-width: 205px;
  background-color: #008aff;
  border-radius: 8px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  padding: 12px 28px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderTop = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const HeaderBottom = styled.div`
  width: 1020px;
  height: 99px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e8ea;
  border-radius: 16px;
`;

const HeaderBottomCategory = styled.div`
  width: 25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 30px;
  justify-content: center;
`;

const GrayLine = styled.div`
  width: 1px;
  height: 100%;
  background-color: #e5e8ea;
`;

const CategorySpan = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #008aff;
`;

const ContentSpan = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  color: #222222;
`;

const Report = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const BottomFixed = styled.div`
  width: 100%;
  height: 94px;
  position: fixed;
  bottom: 0;
  background-color: #fff;
  padding: 16px 16px 24px;
  z-index: 10000;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 1px solid #e5e8ea;
  border-radius: 16px;
  overflow: hidden;
`;

const InfoCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px 0px 16px 20px;
  border-right: 1px solid #e5e8ea;
  border-bottom: 1px solid #e5e8ea;

  &:nth-child(2n) {
    border-right: none;
  }

  &:nth-last-child(-n + 2) {
    border-bottom: none;
  }
`;

const Title = styled.div`
  font-size: 12px;
  color: #008aff;
  font-weight: 500;
  margin-bottom: 4px;
`;

const Content = styled.div`
  font-size: 14px;
  color: #222222;
  font-weight: 700;
`;
